<template>
  <div />
</template>

<script setup lang="ts">
import { ADMIN_ROUTES } from "shared-ui/utils/admin-routes";
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});

const router = useRouter();
const route = useRoute();

onMounted(() => {
  void router.replace({ path: ADMIN_ROUTES.systems, query: route.query });
});
</script>
